import { Text, BoxProps, Flex, Box } from "@chakra-ui/react";
import TextWithTooltip from "components/TextWithTooltip";
import { memo } from "react";
import { NoFieldPreviewProps } from "../fields/types";
import NoFieldPreview from "./NoFieldPreview";

interface Props extends NoFieldPreviewProps {
  title?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
}

const FieldNumberPreviewWrapper = (props: Props & BoxProps) => {
  const {
    title,
    children,
    index,
    prevItemResultCount,
    allItemResultCount,
    ...rest
  } = props;

  return (
    <Flex flexDirection="column" gap="0.5rem" {...rest}>
      <Flex
        fontWeight="bold"
        fontSize={"1.6rem"}
        className="field-title"
        position={"relative"}
        alignItems={"center"}
        gap="0.5rem"
      >
        <NoFieldPreview
          index={index}
          prevItemResultCount={prevItemResultCount}
          allItemResultCount={allItemResultCount}
        />
        <TextWithTooltip
          text={title}
          textProps={{ as: "span", noOfLines: 1 }}
        />
      </Flex>
      <Box className="field-wrapper" pl="1.2rem">
        {children}
      </Box>
    </Flex>
  );
};

export default memo(FieldNumberPreviewWrapper);
